import React, { useEffect } from 'react';
import { Form, Select } from 'antd';

const SupplierContactField = ({
  supplierId,
  form,
  contacts = [],
  isLoading,
}) => {
  useEffect(() => {
    if (!supplierId) return;

    // Always reset first when supplier changes
    form.setFieldsValue({ contactInfoId: null });

    // Run condition after reset
    if (
      contacts.length === 1 &&
      contacts[0]?.label?.toLowerCase().startsWith('sales contact')
    ) {
      form.setFieldsValue({ contactInfoId: contacts[0].value });
    }
  }, [supplierId, contacts, form]);

  if (!supplierId) return null;

  return (
    <Form.Item
      label='Supplier Contact'
      name='contactInfoId'
      colon={false}
      style={{ marginBottom: '16px' }}
      labelCol={{ flex: '100px' }}
      wrapperCol={{ flex: 'auto' }}
      validateTrigger='onSubmit'
      // normalize undefined to null
      getValueFromEvent={(value) => (value === undefined ? null : value)}
    >
      <Select
        placeholder='Please Select Supplier Contact'
        loading={isLoading}
        allowClear
        options={contacts}
        style={{ width: '100%' }}
      />
    </Form.Item>
  );
};

export default SupplierContactField;
